import React from 'react';
import SectionInfoPromo from '../section-info-promo/section-info-promo';
import SectionPromoReleated from '../section-promo-releated/section-promo-releated';
import './content-detail-promo.scss';

const ContentDetailPromo = props => {
    const { info } = props;
    const { tags, titulo } = info;
    return (
        <div>
            <SectionInfoPromo promo={ info }/>
            <SectionPromoReleated promo={ info } />
        </div>
    )
}

export default ContentDetailPromo
